<script lang="ts" src="./FormPlatformSwitch.ts"></script>

<template>
  <div class="flex flex-row justify-between">
    <div class="mx-auto text-sm">
      <!--      <m-icon class="text-green-500" :solid="true" :type="$const.IconTypes.FONT_AWESOME" name="arrows-spin"/>-->
      circularity
    </div>

    <div>
      <span class="switch" @click="$store.app.platformToggle()">
        <input
          :id="id"
          ref="checkbox"
          :checked="modelValues"
          :disabled="isDisabled"
          :name="id"
          class="input"
          type="checkbox"
        />

        <span :class="['slider', color]"></span>
      </span>
    </div>

    <div class="mx-auto text-sm">
      <!--      <m-icon class="text-blue-500" :solid="true" :type="$const.IconTypes.MANUFY" name="trims"/>-->
      production
    </div>
  </div>
</template>


<style lang="scss" scoped>

.switch {
  @apply inline-block w-10 h-5 relative;

  .input {
    @apply w-0 h-0 opacity-0;

    &:focus + .slider {
      @apply shadow-sm;
    }

    &:checked + .slider {
      &::before {
        @apply translate-x-5;
      }
    }
  }

  .slider {
    @apply absolute top-0 right-0 bottom-0 left-0 rounded-2xl cursor-pointer;

    &::before {
      @apply w-3 h-3 absolute bottom-1 left-1 rounded-full bg-neutral-0;
      content: "";
    }
  }

  .slider,
  .slider::before {
    @apply transform transition-all duration-300;
    transition-timing-function: cubic-bezier(0.785, 0.135, 0.150, 0.860);
  }
}

</style>
